import { PubSub } from "@/shared/utils/pubSub";

type YearRangeMode = "single" | "range";

type YearRangeModeChangeCallback = (fieldPath: string, mode: YearRangeMode) => void;

/**
 * Neutral pub-sub channel for year-range mode changes.
 *
 * The toggle publishes after flipping `isRangeMode`.
 * Subscribers (e.g. MAT reconciler) react autonomously.
 *
 * Dependency graph:
 *   MAT module → form/ (subscribes)
 *   year-range toggle → form/ (publishes)
 *   year-range toggle → MAT: ✗ (never)
 */
export const yearRangePubSub = new PubSub<YearRangeModeChangeCallback>();
